import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_MCC_API_KEY,
  authDomain: process.env.REACT_APP_MCC_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_MCC_DB_URL,
  projectId: process.env.REACT_APP_MCC_PROJECT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
